var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2858 7.14324V10.0004C15.2858 10.3793 15.4363 10.7426 15.7042 11.0105C15.9721 11.2784 16.3355 11.429 16.7144 11.429H17.4286C18.1864 11.429 18.9131 11.1279 19.4489 10.5921C19.9848 10.0563 20.2858 9.32957 20.2858 8.57181V4.2861C20.2858 3.90722 20.1353 3.54385 19.8674 3.27595C19.5995 3.00804 19.2361 2.85753 18.8572 2.85753H16.7144C16.2623 2.85709 15.8167 2.74938 15.4144 2.54324C14.0504 1.83144 12.5384 1.44977 11.0001 1.42896C9.45203 1.4453 7.92974 1.82709 6.55721 2.54324C6.16222 2.74172 5.72776 2.84911 5.28578 2.85753H3.14293C2.76405 2.85753 2.40068 3.00804 2.13277 3.27595C1.86487 3.54385 1.71436 3.90722 1.71436 4.2861V8.57181C1.71436 9.32957 2.01538 10.0563 2.55119 10.5921C3.08701 11.1279 3.81374 11.429 4.5715 11.429H5.28578C5.66467 11.429 6.02803 11.2784 6.29594 11.0105C6.56385 10.7426 6.71436 10.3793 6.71436 10.0004V7.14324",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 11.429L16.9858 13.6718C16.7134 15.0592 15.9675 16.3088 14.8757 17.2071C13.7839 18.1054 12.414 18.5966 11.0001 18.5966C9.58625 18.5966 8.21629 18.1054 7.12448 17.2071C6.03266 16.3088 5.28679 15.0592 5.01439 13.6718L4.57153 11.429",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2859 14.2861H11.7145",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.a11ba3c5d8187ce44a6d512ce37232a6.svg";
export { ForwardRef as ReactComponent };